import './App.css';
import {BrowserRouter, Routes, Route, Outlet, Navigate} from "react-router-dom";
import AccountLanding from "./components/account/account_info_landing/AccountLanding";
import RegisterLanding from "./components/registration/register_landing/RegisterLanding";
import PersonalLanding from "./components/personal/personal_info_landing/PersonalLanding";
import FinancialLanding from "./components/financial/financial_landing/FinancialLanding";
import AffiliationLanding from "./components/affiliation/affiliation_info_landing/AffiliationLanding";
import ExperienceLanding from "./components/experience/experience_info_landing/ExperienceLanding";
import ConditionsLanding from "./components/conditions/conditions_landing/ConditionsLanding";
import ReviewLanding from "./components/review/review_landing/ReviewLanding";
import SignatureLanding from "./components/signature/signature_landing/SignatureLanding";
import WelcomeToLanding from "./components/welcome/welcome_to_landing/WelcomeToLanding";
import {useState} from "react";
import WelcomeBackInfo from "./components/welcome-back/welcome_back_info/WelcomeBackInfo";
import Login from "./components/login/login_info/Login";
import CustodialAccLanding from "./components/custodial_acc/custodial_account_landing/CustodialAccLanding";
import OwnerInfoLanding from "./components/owner_info/owner_info_landing/OwnerInfoLanding";
import AuthorizedSignersLanding
    from "./components/authorized_signers/authorized_signers_landing/AuthorizedSignersLanding";
import VerifyPasswordLanding from "./components/verify_password/verify_password_landing/VerifyPasswordLanding";
import PageScroll from "./components/page_scroll/PageScroll";
import {setAppData} from "./redux/register_store";
import {connect} from "react-redux";
import AboutLanding from "./components/about_us/about_info_landing/AboutLanding";

function App({appData}) {
    const [response, setResponse] = useState();
    const updateResponse = (data) => {
        setResponse(data);
    };

    const ProtectedRoute = ({ redirectPath = '/' }) => {
        if (!appData.app_id) {
            return <Navigate to={redirectPath} replace />;
        }

        return <Outlet/>
    };

    return (
        <div className="App">
            <BrowserRouter>
                <PageScroll>
                    <Routes>
                        <Route path="/" element={<RegisterLanding/>}/>
                        <Route path="/about-us" element={<AboutLanding />}/>

                        <Route element={<ProtectedRoute />}>
                            <Route path="personal" element={<PersonalLanding/>}/>
                            <Route path="financial" element={<FinancialLanding/>}/>
                            <Route path="affiliation" element={<AffiliationLanding/>}/>
                            <Route path="account" element={<AccountLanding/>}/>
                            <Route path="experience" element={<ExperienceLanding/>}/>
                            <Route path="conditions" element={<ConditionsLanding/>}/>
                            <Route path="review" element={<ReviewLanding/>}/>
                            <Route path="signature" element={<SignatureLanding/>}/>
                            <Route path="welcome-to" element={<WelcomeToLanding/>}/>
                            <Route path="custodial-account" element={<CustodialAccLanding/>}/>
                            <Route path="owner-info" element={<OwnerInfoLanding/>}/>
                            <Route path="authorized-signers" element={<AuthorizedSignersLanding/>}/>
                        </Route>
                        <Route path="welcome-back" element={<WelcomeBackInfo response={response}/>}/>
                        <Route path="login" element={<Login updateResponse={updateResponse}/>}/>
                        <Route path="verify-password" element={<VerifyPasswordLanding/>}/>
                    </Routes>
                </PageScroll>
            </BrowserRouter>
        </div>
    );
}

const mapStateToProps = (state) => ({
    appData: state.appData,
});

const mapDispatchToProps = {
    setAppData,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);